
import {
  defineComponent,
  ref,
  useMeta,
  useContext,
  useFetch,
  useRoute,
  computed,
  watch,
  useRouter,
  watchEffect,
} from '@nuxtjs/composition-api';
import {
  useFetchFaqs,
  useAlternateLinks,
  useFetchFaqsCategories,
} from '@/composables';

export default defineComponent({
  setup() {
    const { i18n } = useContext();
    const route = useRoute();
    const router = useRouter();
    const { alternateLinks } = useAlternateLinks();

    const currentPage = computed(() => route.value.query.page);
    const searchQuery = computed(() => route.value.query.search);
    const searchString = ref('');
    const selectedCategoryId = computed(() => route.value.query.category_id);

    const { questions, fetchQuestions, loading, pagesCount } = useFetchFaqs({
      currentPage,
      searchQuery,
      categoryId: selectedCategoryId,
    });

    const { categories, fetchCategories } = useFetchFaqsCategories();

    watch(selectedCategoryId, () => {
      fetchQuestions();
    });

    watchEffect(() => {
      searchString.value = searchQuery.value;
    });

    const search = () => {
      router.push({
        query: {
          search: searchString.value || undefined,
        },
      });
    };

    useFetch(async () => {
      await fetchCategories();
      await fetchQuestions();
    });

    const { htmlAttrs } = useMeta({
      title: i18n.t('frequently_asked_questions'),
      meta: [
        {
          property: 'og:title',
          content: i18n.t('frequently_asked_questions'),
        },
      ],
      link: alternateLinks.value,
    });
    htmlAttrs.value = {
      itemscope: true,
      itemtype: 'https://schema.org/FAQPage',
    };

    return {
      categories,
      questions,
      loading,
      pagesCount,
      currentPage,
      selectedCategoryId,
      search,
      searchString,
    };
  },
  head: {},
});
